module.exports = __webpack_public_path__ + "static/media/chicken.7606c940.jpg";